import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import type { FormControl } from '@angular/forms';

import { IconCircleComponent } from '@core/getting-started-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import {
  BadgeComponent,
  BoxComponent,
  HeadingComponent,
  IconComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tla-start-free-trial-dialog-sample-data-lib',
  styleUrls: ['./start-free-trial-dialog-sample-data.component.less'],
  template: `
    <rt-heading margin-bottom-small>{{
      'tl.dashboard.start_trial_dialog.config.sample_data.title' | translate
    }}</rt-heading>
    <div class="container">
      <rt-box (click)="control().setValue(true)" [class.active]="control().value === true">
        <div class="card-container">
          <div class="topbar">
            <rt-icon name="drag-click" size="large" colorToken="colorIconActive" />
            <rt-badge color="success-tint" [text]="'tl.common.recommended' | translate" />
          </div>
          <div class="header">
            {{ 'tl.dashboard.start_trial_dialog.config.sample_data.use_sample_data' | translate }}
          </div>
          <p>
            {{
              'tl.dashboard.start_trial_dialog.config.sample_data.use_sample_data_description'
                | translate
            }}
          </p>
          @if (control().value === true) {
            <rt-icon-circle
              size="medium"
              iconName="check"
              iconColor="colorIconOnprimaryDefault"
              backgroundColor="colorBgPrimaryDefault"
            />
          }
        </div>
      </rt-box>
      <rt-box (click)="control().setValue(false)" [class.active]="control().value === false">
        <div class="card-container">
          <div class="topbar">
            <rt-icon name="clinical-notes" size="large" colorToken="colorIconActive" />
          </div>
          <div class="header">
            {{
              'tl.dashboard.start_trial_dialog.config.sample_data.explore_without_data' | translate
            }}
          </div>
          <p>
            {{
              'tl.dashboard.start_trial_dialog.config.sample_data.explore_without_data_description'
                | translate
            }}
          </p>

          @if (control().value === false) {
            <rt-icon-circle
              size="medium"
              iconName="check"
              iconColor="colorIconOnprimaryDefault"
              backgroundColor="colorBgPrimaryDefault"
            />
          }
        </div>
      </rt-box>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IconCircleComponent,
    HeadingComponent,
    BoxComponent,
    BadgeComponent,
    IconComponent,
    TranslatePipe,
  ],
})
export class StartFreeTrialDialogSampleDataComponent {
  public control = input.required<FormControl<boolean | null>>();
}
